import { useDispatch } from "react-redux";
import { useCallback } from "react";

import useShallowSelector from "./useShalowSelector";
import { selectUICollaboration } from "../store/ui/selectors";
import { changeCollaboration } from "../store/ui/actionCreators";

export interface onOpen {
    (): void;
}

export interface onClose {
    (): void;
}

export interface onToggle {
    (): void;
}

type UseCollaboration = () => {
    onOpen: onOpen;
    onClose: onClose;
    onToggle: onToggle;
    isOpen: boolean;
};

const useCollaboration: UseCollaboration = () => {
    const { isOpen } = useShallowSelector(selectUICollaboration);
    const dispatch = useDispatch();

    const onOpen: onOpen = useCallback(() => dispatch(changeCollaboration({ isOpen: true })), [dispatch]);

    const onClose: onClose = useCallback(() => dispatch(changeCollaboration({ isOpen: false })), [dispatch]);

    const onToggle: onToggle = useCallback(
        () => dispatch(changeCollaboration({ isOpen: !isOpen })),
        [dispatch, isOpen],
    );

    return { onOpen, onClose, onToggle, isOpen };
};

export default useCollaboration;
